export enum UpgradeAction {
    SENTIMENT_CHECK = "SENTIMENT_CHECK",
    OPEN_AI = "OPEN_AI",
    MULTI_CAMPAIGN = "MULTI_CAMPAIGN",
    ZAPIER = "ZAPIER",
    UPGRADE_ALL = "UPGRADE_ALL",
    CANCEL = "CANCEL",
    DISABLED_SENTIMENT_CHECK = "DISABLED_SENTIMENT_CHECK",
}

export interface UpgradePlanRequest {
    action: UpgradeAction,
    businessId: String,
    businessName: String,
    locationId: String,
    locationName: String,
    userName: String,
    userEmail: String,
    cancelFeatureButton: String
}